export default __webpack_public_path__ + "static/media/google-icon.39128c7c.svg";